// extracted by mini-css-extract-plugin
export default {"wrapper_app":"NotFoundPage_wrapper_app__UgywQ","image_wrapper":"NotFoundPage_image_wrapper__yqqrA","back_button":"NotFoundPage_back_button__SdQP0"};